/**
 * interface pour injection du contexte d'environnement dans le modèle
 */
export interface EnvConfig {
    production: boolean,
    byPassPermission: boolean,
    apiUrl: string,
    domUrl: string,
    batchUrl: string,
    connectUrl: string,
    computeUrl:string,
    client: string,

    meHref: string,
    domHref: string,
    cnxHref: string,

    allkeyMeSuffix: string,
    keycloakUrl: string,
    wsUrl: string,

/*    specifUrl?: string, // url de base des endpoints du  backend specif
    specifHref?: string // /nomduspecif pour retour keycloak*/
	specifUrl?: {[key: string]: string}; // url de base des endpoints des backends specifs
	specifHref?: {[key: string]: string}; // nom des specifs pour retour keycloak

};

/**
 * gestion dynamique des params d'environnement
 */
export class EnvironnementManager {
    
    private static  _envConfig: EnvConfig = null;

    public static get envConfig(): EnvConfig {
        return this._envConfig;
    }

    public static async checkEnvConfig(): Promise<EnvConfig> {
        if(!this._envConfig) {
            await fetch('assets/env.json').then(async response => {
                this._envConfig = JSON.parse(await response.text());

                return Promise.resolve();
              });
        }

        // console.log('EnvironnementManager', this._envConfig);
        return this._envConfig;
    }


}